import React, { useEffect } from "react";
import PhotoGrid from "./PhotoGrid";
import AlbumList from "./AlbumList";
import NoAlbums from "./NoAlbums";
import LibraryView from "../components/LibraryView";
import FolderView from "../components/FolderView";
import NewFolderScreen from "./NewFolderScreen";
import { CreateFolderType, EnhancedFolder } from "./types";
const gssNewLoader = require("../../../assets/gss-loader.gif");

const RenderContentArea = (props: {
  handleCreateFolder: (type: CreateFolderType) => void;
  handleCreateEvent?: any;
  handleFolderClick?: any;
  handleEventClick?: any;
  handlePageChange?: any;
  navigateToRoot?: any;
  navigateToAlbum?: any;
  fetchAlbumPhotosFunction?: any;
  onDeleteSuccess?: any;
  showActionTooltip?: any;
  togglePhotoSelection?: any;
  clearSelection?: any;
  onCreateAlbumSuccess?: any;
  updateAlbumsList?: any;
  onEditSuccessUpdateAlbum?: any;
  setActiveShareModalEventId?: any;
  setPrivacyPopupId?: any;
  setMarkUploadCompletePopup?: any;
  isPendingURLResolution?: any;
  handleAlbumClick?: any;
  setShowNewAlbumModal?: any;
  selectedEvent?: any;
  selectedView?: any;
  selectedFolderId?: any;
  albums?: any;
  eventsList?: any;
  eventsView?: any;
  openedEvents?: any;
  selectedAlbumPhotos?: any;
  selectedAlbum?: any;
  loading?: any;
  isMobile?: any;
  eventCurrentPage?: any;
  photoCurrentPage?: any;
  nextPage?: any;
  albumLoadingEventId?: any;
  photosLoading?: any;
  nextPhotoPage?: any;
  photosCount?: any;
  eventListCurrentPage?: any;
  eventListNextPage?: any;
  activeShareModalEventId?: any;
  privacyPopupId?: any;
  markUploadPopupId?: any;
  eventsLoading?: any;
  showNewAlbumModal?: any;
  selectedMediaId?: any;
  confirmationLoader?: any;
  showEventsFilter?: any;
  selectedEventFilter?: any;
  noFilteredData?: any;
  isFilterEventsLoading?: any;
  selectedFolderData?: any;
  rootFolders?: any;
  openCreateEventModal: () => void;
  libraryRootFolders?: EnhancedFolder[];
}) => {
  const {
    loading,
    selectedView,
    selectedFolderData,
    selectedEvent,
    selectedAlbum,
    albums,
    noFilteredData,
    selectedAlbumPhotos,
    isMobile,
    photoCurrentPage,
    nextPhotoPage,
    photosLoading,
    rootFolders,
    eventsView,
    eventCurrentPage,
    nextPage,
    albumLoadingEventId,
    eventsLoading,
    handleCreateFolder,
    handleCreateEvent,
    handleFolderClick,
    handleEventClick,
    handlePageChange,
    navigateToRoot,
    navigateToAlbum,
    fetchAlbumPhotosFunction,
    onDeleteSuccess,
    showActionTooltip,
    selectedMediaId,
    togglePhotoSelection,
    clearSelection,
    onCreateAlbumSuccess,
    updateAlbumsList,
    onEditSuccessUpdateAlbum,
    setActiveShareModalEventId,
    setPrivacyPopupId,
    setMarkUploadCompletePopup,
    isPendingURLResolution,
    openCreateEventModal
  } = props;

  if (loading || isPendingURLResolution()) {
    return (
      <div className="gss-loader">
        <img src={gssNewLoader} />
      </div>
    );
  }
  if (selectedAlbum && selectedEvent && photosLoading !== selectedAlbum.id) {
    return (
      <PhotoGrid
        selectedAlbumPhotos={selectedAlbumPhotos}
        selectedEvent={selectedEvent}
        selectedAlbum={selectedAlbum}
        isMobile={isMobile}
        navigateToAlbum={navigateToAlbum}
        navigateToRoot={navigateToRoot}
        fetchAlbumPhotosFunction={fetchAlbumPhotosFunction}
        handlePageChange={page => handlePageChange("photo", page)}
        nextPhotoPage={nextPhotoPage}
        photoCurrentPage={photoCurrentPage}
        photosLoading={photosLoading}
        onDeleteSuccess={onDeleteSuccess}
        showActionTooltip={showActionTooltip}
        selectedMediaId={selectedMediaId}
        togglePhotoSelection={togglePhotoSelection}
        clearSelection={clearSelection}
      />
    );
  }

  if (selectedAlbum && selectedEvent && photosLoading === selectedAlbum.id) {
    return (
      <div className="gss-loader">
        <img src={gssNewLoader} />
      </div>
    );
  }

  if (selectedEvent && albums[selectedEvent.id]?.length > 0) {
    return (
      <AlbumList
        selectedEvent={selectedEvent}
        albums={albums[selectedEvent.id]}
        handleAlbumClick={props.handleAlbumClick}
        navigateToRoot={navigateToRoot}
        photosLoading={photosLoading}
        showActionTooltip={showActionTooltip}
        onCreateAlbumSuccess={onCreateAlbumSuccess}
        updateAlbumsList={updateAlbumsList}
        onEditSuccessUpdateAlbum={onEditSuccessUpdateAlbum}
      />
    );
  }

  if (selectedEvent && albums[selectedEvent.id] === undefined) {
    // Show loading state while albums are being fetched
    return (
      <div className="gss-loader">
        <img src={gssNewLoader} />
      </div>
    );
  }

  if (selectedEvent) {
    return (
      <NoAlbums
        showNewAlbumModal={() => props.setShowNewAlbumModal(selectedEvent.id)}
        canCreateAlbums={selectedEvent.canCreateAlbums}
      />
    );
  }

  if (
    selectedView === "empty-folder" ||
    (selectedFolderData?.folderMeta &&
      selectedFolderData.folders.length === 0 &&
      selectedFolderData.events.length === 0)
  ) {
    return (
      <NewFolderScreen
        // folderData={selectedFolderData.folderMeta}
        handleCreateFolder={handleCreateFolder}
        onGalleryClick={openCreateEventModal}
        // onCreateEventClick={handleCreateEvent}
      />
    );
  }

  if (selectedView === "folder" && selectedFolderData) {
    return (
      <FolderView
        folders={selectedFolderData.folders}
        events={selectedFolderData.events}
        onFolderClick={handleFolderClick}
        onClickCreateSubFolder={handleCreateFolder}
        onCreateEventClick={handleCreateEvent}
        parentFolder={selectedFolderData}
        albumLoadingId={albumLoadingEventId}
        showActionTooltip={showActionTooltip}
        handleEventClick={handleEventClick}
        setActiveShareModalEventId={setActiveShareModalEventId}
        setMarkUploadCompletePopup={setMarkUploadCompletePopup}
        setPrivacyPopupId={setPrivacyPopupId}
        currentPage={eventCurrentPage}
        nextPage={nextPage}
        handlePageChange={page => handlePageChange("event", page)}
        loading={eventsLoading}
      />
    );
  }

  return (
    <LibraryView
      folders={rootFolders?.map((folder: any, index: number) => ({
        ...folder,
        displayType: index === 0 ? "empty" : "populated"
      }))}
      onFolderClick={handleFolderClick}
      onClickCreateLibraryFolder={handleCreateFolder}
      onCreateEventClick={handleCreateEvent}
      events={eventsView}
      isMobile={isMobile}
      handleEventClick={handleEventClick}
      currentPage={eventCurrentPage}
      nextPage={nextPage}
      handlePageChange={page => handlePageChange("event", page)}
      setActiveShareModalEventId={setActiveShareModalEventId}
      setPrivacyPopupId={setPrivacyPopupId}
      setMarkUploadCompletePopup={setMarkUploadCompletePopup}
      albumLoading={albumLoadingEventId}
      loading={eventsLoading}
      showActionTooltip={showActionTooltip}
    />
  );
};

export default RenderContentArea;
